var _path, _ellipse, _ellipse2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageErrorIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 292,
    viewBox: "0 0 476 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.133 184.593C257.133 184.593 119.556 200.935 87.6497 108.497C55.7433 16.0592 180.131 -16.1243 226.858 7.41649C273.585 30.9573 310.64 96.6048 351.254 78.2964C391.868 59.988 412.805 85.8825 407.969 103.144C403.134 120.406 379.923 171.253 257.133 184.593Z",
    fill: "url(#paint0_linear_163_11969)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 35.4211,
    ry: 35.3634,
    transform: "matrix(0.318391 0.947959 -0.947565 0.319564 228.64 171.886)",
    fill: "#FDA29B",
    stroke: "#42307D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 26.5658,
    ry: 26.5225,
    transform: "matrix(0.318391 0.947959 -0.947565 0.319564 228.638 171.886)",
    fill: "#F04438",
    stroke: "#42307D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218 162.009L239 183.009",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218 162.009L239 183.009",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239 162.009L218 183.009",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.766 141.766C127.766 141.766 122.602 170.355 145.21 164.295C142.091 149.854 134.917 137.977 142.559 123.478C133.201 118.654 127.899 130.173 127.766 141.766Z",
    fill: "#7F56D9",
    stroke: "#42307D",
    strokeWidth: 1.21
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.556 162.886C162.556 162.886 124.601 177.056 135.986 131.219C125.588 147.226 113.747 152.84 113.747 152.84C113.747 152.84 122.891 192.751 106.053 198.99C89.2152 205.228 56.3772 182.983 69.264 153.048C82.1509 123.114 145.961 106.067 154.279 112.092C162.597 118.117 141.3 159.64 162.556 162.886Z",
    fill: "#7F56D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.556 162.886C162.556 162.886 124.601 177.056 135.986 131.219C125.588 147.226 113.747 152.84 113.747 152.84C113.747 152.84 122.891 192.751 106.053 198.99C89.2152 205.228 56.3772 182.983 69.264 153.048C82.1509 123.114 145.961 106.067 154.279 112.092C162.597 118.117 141.3 159.64 162.556 162.886Z",
    stroke: "#42307D",
    strokeWidth: 1.21
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.868 162.43C163.868 162.43 159.345 140.536 174.519 130.346C178.112 127.932 181.549 125.517 184.206 122.912C173.569 118.296 161.51 118.217 150.813 122.692C150.632 123.401 150.372 124.087 150.039 124.737C145.522 133.466 137.158 169.818 163.868 162.43Z",
    fill: "#7F56D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.29 99.6317C145.21 102.439 154.562 116.003 150.016 124.737C145.47 133.471 137.135 169.794 163.844 162.429C163.844 162.429 159.322 140.536 174.496 130.346",
    stroke: "#42307D",
    strokeWidth: 1.21
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M227.88 127.902C217.685 130.034 204.729 119.983 188.527 108.545C186.343 102.41 179.285 94.8835 164.486 85.0806C127.91 60.8651 30.413 28.1234 3.46674 229.663C22.8692 287.354 82.1741 289.843 72.8165 270.099C63.459 250.355 121.043 279.659 122.29 273.842C92.1497 213.76 194.626 181.948 195.458 171.972C181.532 134.141 91.9417 206.054 86.5351 174.283C81.1286 142.511 135.385 111.093 170.291 132.293C205.197 153.493 233.905 134.58 227.88 127.902Z",
    fill: "#D6BBFB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M195.458 171.972C193.529 166.739 190.15 163.608 185.748 162.008C182.802 166.473 190.184 177.073 167.478 187.887C99.9359 218.503 104.049 257.749 107.982 271.439C115.797 273.987 121.886 275.685 122.284 273.837C92.1495 213.76 194.626 181.948 195.458 171.972Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M188.313 108.008C185.904 101.971 178.84 94.6121 164.486 85.1038C127.91 60.8652 30.413 28.1235 3.46674 229.663C8.18594 243.712 15.2792 254.502 23.1696 262.457C8.03576 218.439 35.8773 89.5113 92.0861 75.8728C150.686 61.6913 185.829 104.819 188.313 108.008Z",
    fill: "#7F56D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M190.479 176.749C189.422 173.636 185.228 164.584 173.728 168.922C162.141 173.307 156.064 189.943 162.863 192.97",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M190.479 176.749C189.422 173.636 185.228 164.584 173.728 168.922C162.141 173.307 156.064 189.943 162.863 192.97",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M66.3587 104.981C78.021 90.5394 90.619 83.4573 104.413 81.1351C164.902 70.9452 203.972 132.893 227.88 127.925C227.176 130.889 218.182 136.33 200.922 122.38C183.663 108.429 111.558 64.7411 85.3972 104.392C68.5768 132.795 54.6906 119.451 66.3587 104.981Z",
    fill: "#7F56D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3586 104.981C77.8361 92.463 90.6189 83.4573 104.413 81.1351C164.902 70.9452 203.972 132.893 227.88 127.925C233.905 134.58 205.249 153.475 170.308 132.269C135.368 111.064 81.1343 142.454 86.5525 174.259C91.9706 206.065 181.549 134.141 195.475 171.949C194.626 181.948 74.1277 218.849 133.046 289.687",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2784 117.377C57.9908 116.126 58.7109 114.89 59.4387 113.669",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8073 276.436C85.8073 276.436 113.25 275.5 121.354 287.989C129.459 300.477 69.5991 280.15 85.8073 276.436Z",
    fill: "#7F56D9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M188.527 108.551C186.349 102.41 179.285 94.8893 164.486 85.0807C127.91 60.8652 25.3241 24.825 1.00024 250.551",
    stroke: "#42307D",
    strokeWidth: 1.21
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M437.247 258.973H156.59",
    stroke: "#42307D",
    strokeWidth: 1.21
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M223.837 128.312L223.623 128.122C217.928 127.625 211.493 124.24 204.192 119.457C200.923 119.931 200.258 122.6 204.885 127.481C215.415 138.623 223.837 128.312 223.837 128.312Z",
    fill: "white",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M167.478 137.787C167.478 137.683 167.478 137.619 167.478 137.619C167.478 137.619 156.751 139.352 155.619 148.918C154.695 156.751 159.928 160.593 163.556 160.287C163.036 155.989 162.556 146.007 167.478 137.787Z",
    fill: "white",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M139.613 174.439C142.426 173.467 145.304 172.695 148.226 172.128",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.253 179.979L128.372 178.714",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7349 158.791C80.2793 162.857 79.2022 167.049 78.5176 171.314C77.0446 181.059 78.1017 192.56 92.2593 190.163C102.807 188.384 112.014 185.195 120.309 181.949",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M146.591 119.388C146.591 119.388 169.413 122.357 180.041 131.519C190.669 140.681 194.308 130.364 186.354 125.454C178.401 120.544 135.125 112.127 146.591 119.388Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M139.613 120.804C139.613 120.804 130.215 123.611 131.151 120.804C132.087 117.996 141.964 115.819 139.613 120.804Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M99.1681 252.423C99.1681 252.423 102.882 224.834 116.075 218.341C129.268 211.849 108.814 210.196 99.1681 224.465C89.5217 238.733 96.8922 262.954 99.1681 252.423Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2927 101.428C44.2416 79.7082 73.637 51.9055 125.254 54.7187",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1412 113.143C23.1463 111.266 24.29 109.25 25.607 107.13",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2961 126.059C16.2961 126.059 17.0702 123.749 18.7915 119.936",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M215.507 118.984C220.364 121.89 226.093 122.985 231.68 122.074C241.024 120.664 240.709 128.073 235.667 134.189",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M209.291 113.67C209.988 114.545 210.761 115.357 211.602 116.096",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M464.337 214.696L469.269 204.05",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M467.664 218.127L475 214.113",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M459.53 213.477L459.634 205.113",
    stroke: "#42307D",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M402.977 133.291C399.175 141.44 385.748 142.504 380.135 138.66C364.467 128.195 339.585 111.978 321.71 119.906C305.339 127.181 308.35 157.787 307.053 172.699C305.598 190.958 303.234 213.465 286.37 223.893C251.639 245.31 192.375 228.058 185.149 185.443",
    stroke: "#7F56D9",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.03 6.03"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M419.662 141.591L343.368 102.862C341.222 101.703 340.562 99.2999 341.423 97.1631L364.339 52.1782C365.503 50.0343 367.911 49.3732 370.051 50.2301L446.344 88.9585C448.49 90.1176 449.15 92.5211 448.29 94.6578L425.373 139.643C424.21 141.787 421.801 142.448 419.662 141.591Z",
    fill: "#7F56D9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M419.662 141.591L343.368 102.862C341.222 101.703 340.562 99.2999 341.423 97.1631L364.339 52.1782C365.503 50.0343 367.911 49.3732 370.051 50.2301L446.344 88.9585C448.49 90.1176 449.15 92.5211 448.29 94.6578L425.373 139.643C424.21 141.787 421.801 142.448 419.662 141.591Z",
    fill: "#D6BBFB",
    stroke: "#42307D",
    strokeWidth: 1.41
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M362.901 55.5378L387.501 98.8041C389.392 102.086 393.072 104.116 397.001 103.722L445.936 97.7366L396.147 106.161C391.62 106.871 387.327 104.553 385.12 100.674L362.901 55.5378Z",
    fill: "#7F56D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_11969",
    x1: 245.568,
    y1: 0,
    x2: 174.304,
    y2: 157.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4EAFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageErrorIcn);
export default __webpack_public_path__ + "static/media/message-error-icn.b0b1081eef63dbd43f09eaf034abc92f.svg";
export { ForwardRef as ReactComponent };